<style scoped>
.pay-details-box {
  text-align: center;
}
.pay-modal-text {
  font-size: 12px;
  color: var(--color-text-dark);
  font-weight: bold;
}
.value {
  font-size: 20px;
}
.currency {
  font-size: 14px;
  color: var(--color-neutral);
}

.footerText {
  text-align: center;
  color: var(--color-neutral);
}

.refund {
  text-align: center;
  color: var(--color-neutral);
}

.refund:hover {
  color: var(--color-info);
}

.comission-info-text {
  text-align: center;
  color: #f09fa2;
}
</style>

<template>
  <div>
    <Modal
      :value="show"
      width="500"
      class="pay-details-box"
      @input="$emit('on-cancel', $event)"
    >
      <p
        slot="header"
        style=" text-align:center"
      >
        <span style="font-size: 16px;">{{ $text.tr('Счет') }} {{ headerText }}</span>
      </p>
      <!--      <div style="height: 25px">-->
      <!--        <span style="font-size: 14px;">CТАТУС </span>-->
      <!--        <span style="font-size: 14px; color: var(--color-info)">{{ payStatus }}</span>-->
      <!--      </div>-->
      <span
        class="pay-modal-text"
        style="color: var(--color-text-dark)"
      >{{ $text.tr('АДРЕС') }}</span><br>
      <Icon
        @click="$copyToClipboardAndNotify(address)"
        color="gray"
        style="cursor: pointer; margin-bottom: 10px"
        :title="$text.tr('Скопировать')"
        type="ios-copy-outline"
        size="22"
      >
      </Icon>
      <span style="font-size: 16px">{{ address }}</span>
      <div
        v-if="payAsset === 'ETH'"
        class="comission-info-text"
        style="margin-bottom: -5px"
      >
        {{ $text.tr('Внимание! Используйте сеть ERC20') }}
      </div>
      <br>
      <qrcode
        v-if="show"
        :value="address"
        :options="{
              width: 240,
              color: { light: '#ffffff', dark: '#000000' }
        }"
      /><br>
      <span
        class="pay-modal-text"
        style="color: var(--color-text-dark)"
      >{{ $text.tr('КОЛ-ВО') }}</span><br>
      <Icon
        @click="$copyToClipboardAndNotify(amount)"
        color="gray"
        style="cursor: pointer; margin-bottom: 10px"
        :title="$text.tr('Скопировать')"
        type="ios-copy-outline"
        size="22"
      >
      </Icon>
      <span class="value">{{ amount }}</span><span class="currency"> {{ payAsset.replace('USDT','USDT ') }}</span>
      <span style="color: var(--color-text-dark); font-size: 15px;"> (${{ amountUsd }})</span>
      <div class="comission-info-text">
        {{ $text.tr('Пожалуйста, учитывайте комиссию за перевод или вывод с биржи.') }}
      </div>
      <div slot="footer">
        <div
          v-if="this.status === 'ожидает оплаты'"
          class="footerText"
        >
          {{ $text.tr('Cчет действителен в течение 6 часов.') }}<br>
          {{ $text.tr('Оплачивая этот счет, вы подтверждаете свое согласие с') }} <br>
          <a
            class="refund"
            target="_blank"
            :href="refundPolicyLink"
          >
            {{ $text.tr('Политикой возврата средств.') }}</a>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
export default {
  name: 'payModal',
  props: ['show', 'address', 'amount', 'amountUsd', 'asset', 'status', 'id'],
  data: function () {
    return {}
  },
  computed: {
    refundPolicyLink () {
      if (
        this.$store.state.sys.lang === 'es' ||
        this.$store.state.sys.lang === 'en'
      ) {
        return 'refund_policy_en.html'
      }
      return 'refund_policy.html'
    },
    payAsset () {
      if (this.asset === 'BCH') {
        return 'BCHABC'
      }
      return this.asset
    },
    payStatus () {
      return this.status.toUpperCase()
    },
    headerText () {
      if (this.id) {
        return '#' + this.id + ' (' + this.$text.tr(this.status) + ')'
      }
      return this.$text.tr('на оплату')
    }
  }
}
</script>
